import React, { ReactNode } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { isStaffEmail } from "@utils/user_utils";

interface Props {
    children: ReactNode;
    label?: string;
}

interface State {
    hasError: boolean;
}

interface InnerProps extends Props {
    isStaff: boolean;
}

class ArtifactErrorBoundaryInner extends React.Component<InnerProps, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error(
            `[ArtifactErrorBoundary${this.props.label ? ` – ${this.props.label}` : ""}] Caught error:`,
            error,
            info
        );
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        if (!this.props.isStaff) return <></>;

        return (
            <div className="chat-v2-artifact-error">
                <span className="chat-v2-artifact-error-icon">⚠️</span>
                <span>"{this.props.label ?? "artifact"}" failed to render</span>
            </div>
        );
    }
}

const ArtifactErrorBoundary: React.FC<Props> = ({ children, label }) => {
    const { user } = useAuth0();
    const isStaff = isStaffEmail(user?.email);
    return (
        <ArtifactErrorBoundaryInner isStaff={isStaff} label={label}>
            {children}
        </ArtifactErrorBoundaryInner>
    );
};

export default ArtifactErrorBoundary;
